export default __webpack_public_path__ + "static/media/resetPassword.b6639d42.png";